

function ShieldedCombatTier9DesignTemplate() {
    return (
        <div>
            <hr className="HorizontalLineBlue" />
            <b className="AbilityHeader animationcolorWhiteOrangeFlashing">DESIGN INSIGHTS</b>
            <hr className="HorizontalLineBlue" />
            <div className="animationFadeIn">
                As with many Tier 9 Talents, Unbreakable carves out a shining moment that
                is both powerful and unforgettable for the player.
            </div>
            <p>
                <b className="AbilityHeaderSmall">WHY DOES IT WORK ON SPELLS & ATTACKS THAT PASS NEAR YOU?</b>
                <div className="animationFadeIn">
                    This gives the ability both an extremely cool thematic element, and a powerful boost to its effectiveness to insure
                    it is memorable.
                    <br />
                    Notice that spells passing near you include spells & attacks aimed at people behind you if a line drawn from the Attacker
                    passes within 5ft of you on its way to your ally, allowing you to deflect them masterfully, resulting in 0
                    effect and damage for both you and the protected ally standing behind you.
                    <p />
                    Imagine a stalwart defender casually swatting away or blocking every single Bolt of Lightning thrown by several
                    Aeromancers. Wouldn't that make you feel like the impenetrable anchor of your team, a beacon that provides substantial
                    protection to anyone who stands behind you?
                </div>
            </p>
            <br />
        </div>
    )
}

export { ShieldedCombatTier9DesignTemplate };